var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconGiftColored(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5506 12V22H3.91016V12",
    fill: "#FADB5E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5506 12V22H3.91016V12",
    stroke: "#6A7889",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5056 7H1.95508V12H21.5056V7Z",
    fill: "#FF6E75",
    stroke: "#6A7889",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7305 22V7",
    stroke: "#6A7889",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7304 7H7.33151C6.68337 7 6.06178 6.73661 5.60347 6.26777C5.14517 5.79893 4.8877 5.16304 4.8877 4.5C4.8877 3.83696 5.14517 3.20107 5.60347 2.73223C6.06178 2.26339 6.68337 2 7.33151 2C10.7529 2 11.7304 7 11.7304 7Z",
    stroke: "#6A7889",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7305 7H16.1293C16.7775 7 17.3991 6.73661 17.8574 6.26777C18.3157 5.79893 18.5732 5.16304 18.5732 4.5C18.5732 3.83696 18.3157 3.20107 17.8574 2.73223C17.3991 2.26339 16.7775 2 16.1293 2C12.708 2 11.7305 7 11.7305 7Z",
    stroke: "#6A7889",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGiftColored);
export default __webpack_public_path__ + "static/media/icon-gift-colored.4d6bf9f0.svg";
export { ForwardRef as ReactComponent };